import React from "react";
import {
  Checkbox,
  IconButton,
  Input,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip
} from "@material-ui/core";
import { API_URL } from "../../constants/api";
import CancelIcon from "@material-ui/icons/Cancel";
import EditIcon from "@material-ui/icons/Edit";
import { apiBatchRequest, apiPost, apiRequest } from "../../utils/api_service";
import SaveIcon from "@material-ui/icons/Save";
import { ShowToast, toastType } from "../../utils/toast-service";
import { IsSectionVisible, removeDuplicates } from "../../utils/helper";
import { SECTIONS } from "../../constants/appConstants";

class ConfigureDC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataCenterList: [],
      isEnable: 1,
      IdToEdit: null,
      DwIdByAPI: undefined,
      EnteredPropertyCode: undefined,
      PropertyDataUltiPro: undefined,
      LocationDataUltiPro: undefined,
      selectedPropertyUltipro: [],
      ultiProLocationId: undefined
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.getRequiredData();
  }

  /**
   * Onload function. get required master data for screen
   */
  getRequiredData = () => {
    apiBatchRequest([
      {
        url: API_URL.dashBoard.getDatacenterListWithLocation + "?ShowAll=" + 1,
        key: "dataCenterList"
      },
      {
        url: API_URL.datacenter.GetAllUltiProLocation + "?ShowAll=" + 1,
        key: "LocationDataUltiPro"
      },
      {
        url: API_URL.datacenter.GetAllUltiProProperty + "?ShowAll=" + 1,
        key: "PropertyDataUltiPro"
      }
    ]).then(({ dataCenterList, LocationDataUltiPro, PropertyDataUltiPro }) => {
      this.setState({
        dataCenterList: dataCenterList.data,
        LocationDataUltiPro: LocationDataUltiPro.data,
        PropertyDataUltiPro: PropertyDataUltiPro.data || []
      });
    });
  };

  /**
   * call on location change
   * @param {*} value 
   */
  handelLocationChange = value => {
    this.setState({ ultiProLocationId: value });
  };

  // getDataCenterList = () => {
  //   var params = {
  //     ShowAll: 1,
  //   };
  //   apiRequest({
  //     url: API_URL.dashBoard.getDatacenterListWithLocation,
  //     params,
  //   }).then(({ data: dataCenterList }) => {
  //     this.setState({
  //       dataCenterList: dataCenterList,
  //     });
  //   });
  // };

  // getUltiProDataLocationList = () => {
  //   var params = {
  //     ShowAll: 1,
  //   };
  //   apiRequest({
  //     url: API_URL.UltiProService.GetAllLocations,
  //   }).then(({ data: LocationDataUltiPro }) => {
  //     this.setState({
  //       LocationDataUltiPro: LocationDataUltiPro,
  //     });
  //   });
  // };

  // getUltiProPropertyLocationList = () => {
  //   apiRequest({
  //     url: API_URL.UltiProService.GetOrganizationLevel4Details,
  //   }).then(({ data: PropertyDataUltiPro }) => {
  //     this.setState({
  //       PropertyDataUltiPro: PropertyDataUltiPro,
  //     });
  //   });
  // };

  /**
   * get property Id by given code
   * @param {*} value 
   * @returns 
   */
  getPropertyIdByCode = value => {
    if (value == null || value == undefined || value == "") {
      return false;
    }
    const params = {
      id: value
    };
    apiRequest({
      url: API_URL.config.GetPropertyIdByPropertyCode,
      params
    }).then(({ data: propertyData }) => {
      if (propertyData.data.length > 0) {
        this.setState({
          DwIdByAPI: propertyData.data[0].propertyId,
          EnteredPropertyCode: value
        });
      } else {
        ShowToast(
          "Please enter valid property code",
          toastType.ERROR,
          5000,
          200
        );
        this.setState({
          DwIdByAPI: undefined,
          EnteredPropertyCode: undefined
        });
      }
    });
  };

  /**
   * call on data center value change
   * @param {*} DcId 
   * @param {*} row 
   * @param {*} ultiProLocationId 
   * @param {*} selectedPropertyUltipro 
   */
  handelDataCenterChange = (
    DcId,
    row,
    ultiProLocationId,
    selectedPropertyUltipro
  ) => {
    this.setState({
      IdToEdit: DcId,
      EnteredPropertyCode: row.propertyCode,
      DwIdByAPI: row.dwPropertyId,
      isEnable: row.statusID,
      ultiProLocationId: ultiProLocationId,
      selectedPropertyUltipro: (selectedPropertyUltipro || "").split(",")
    });
  };

  /**
   * call on check box value selection or change in checkbox value
   * @param {*} value 
   */
  changeCheckBox = value => {
    if (value == false) {
      value = 2;
    } else {
      value = 1;
    }
    this.setState({ isEnable: value });
  };

  /**
   * Function to Save records
   * @returns 
   */
  saveRecord = () => {
    if (this.state.EnteredPropertyCode == undefined) {
      ShowToast("Please enter valid property code", toastType.ERROR, 5000, 200);
      return;
    }
    const params = {
      propertyId: this.state.IdToEdit,
      dwPropertyId: this.state.DwIdByAPI,
      statusId: this.state.isEnable.toString(),
      propertyCode: this.state.EnteredPropertyCode.toString(),
      ultiProLocationId: this.state.ultiProLocationId,
      ultiProPropertyId: this.state.selectedPropertyUltipro.join(",")
    };

    apiPost({
      url: API_URL.config.UpdateDataCenterConfiguration,
      postBody: params
    }).then(({ data: response, success: success }) => {
      if (response.data.Success == 0) {
        ShowToast(response.data.Message, toastType.ERROR, 5000, 200);
        return false;
      }
      if (success == true) {
        ShowToast("Record Updated Successfully", toastType.SUCCESS, 5000, 200);
      }

      this.setState({
        IdToEdit: null,
        isEnable: 1,
        DwIdByAPI: undefined,
        EnteredPropertyCode: undefined
      });
      this.getRequiredData();
    });
  };

  /**
   * call on Ulti pro property change
   * @param {*} options 
   */
  handleOnUltiProPropertyChange = options => {
    const newOption = [];
    options.map(value => newOption.push(parseInt(value)));
    const NewSet = [];
    const values = removeDuplicates(newOption);
    values.forEach(element => {
      const obj = this.state.PropertyDataUltiPro.find(
        x => parseInt(element) == x.ultiProPropertyID
      );
      if (obj != undefined) {
        NewSet.push(obj);
      }
    });

    this.setState({ selectedPropertyUltipro: values });
  };

  /**
   * call for getting the report data
   * @returns 
   */
  CallForGettingTheReportData = () => {
    return false;
  };
  render() {
    const DATA_CENTER = IsSectionVisible(
      SECTIONS.CONFIGURATION,
      SECTIONS.CONFIGURE_DATA_CENTER
    );

    const { dataCenterList } = this.state;

    return (
      <>
        <Table
          aria-labelledby={"tableMenuTitle"}
          size={"small"}
          aria-label={"configuration table"}
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={"configureHeader"}
                className={"content-header"}
                colSpan={2}
              >
                <div className={"content-header d-flex"}>
                  {" "}
                  <div
                    className={"col-xs-11"}
                    style={{ display: "inline-block", alignItems: "center" }}
                  >
                    {"Configure Data Centers\r"}
                  </div>
                  <div className={"col-xs-1"}>
                    {/* <Tooltip title="Save">
                      <IconButton size={"small"} style={{ color: "#FFFFFF" }}>
                        <SaveIcon size={"small"} style={{ fill: "#FFFFFF" }} />
                      </IconButton>
                    </Tooltip> */}
                  </div>
                </div>
              </TableCell>
              {/* <TableCell style={{ textAlign: "right" }}>
           
          </TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <Table style={{ minWidth: "650" }} aria-label={"simple table"}>
                  <TableHead>
                    <TableRow>
                      <TableCell>{"Data Center Name"}</TableCell>
                      <TableCell align={"center"}>{"Enter Property Code"}</TableCell>
                      <TableCell align={"center"}>{"UltiPro Location"}</TableCell>
                      <TableCell align={"center"}>{"UltiPro Property"}</TableCell>
                      <TableCell align={"center"}>{"Dataware House Id"}</TableCell>
                      <TableCell align={"center"}>{"Is Active"}</TableCell>
                      {DATA_CENTER == true ? (
                        <TableCell align={"center"}>{"Action"}</TableCell>
                      ) : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataCenterList.map(row => (
                      <TableRow key={row.name}>
                        <TableCell component={"th"} scope={"row"}>
                          {row.name}
                        </TableCell>

                        <TableCell align={"right"}>
                          {this.state.IdToEdit == row.propertyID ? (
                            <TextField
                              id={"standard-basic"}
                              defaultValue={row.propertyCode}
                              onBlur={e => {
                                this.getPropertyIdByCode(e.target.value);
                              }}
                            />
                          ) : (
                            row.propertyCode
                          )}
                        </TableCell>
                        <TableCell align={"right"} scope={"row"}>
                          {this.state.IdToEdit == row.propertyID ? (
                            <Select
                              style={{ maxWidth: "150px", minWidth: "150px" }}
                              value={this.state.ultiProLocationId}
                              onChange={e =>
                                this.handelLocationChange(e.target.value)}
                            >
                              {this.state.LocationDataUltiPro.map(value => (
                                <MenuItem
                                  key={value.ultiProPropertyID + "locUltiPro"}
                                  value={value.ultiProLocationID}
                                >
                                  {value.description}
                                </MenuItem>
                              ))}
                            </Select>
                          ) : (
                            <span>{row.ultiProLocationDescription}</span>
                          )}
                        </TableCell>

                        <TableCell align={"right"} scope={"row"}>
                          {this.state.IdToEdit == row.propertyID ? (
                            <Select
                              labelId={"demo-multiple-name-label"}
                              id={"demo-multiple-name"}
                              multiple
                              value={this.state.selectedPropertyUltipro}
                              style={{ maxWidth: "150px", minWidth: "150px" }}
                              onChange={event => {
                                this.handleOnUltiProPropertyChange(
                                  event.target.value
                                );
                              }}
                              input={<Input />}
                            >
                              {this.state.PropertyDataUltiPro.map(value => (
                                <MenuItem
                                  key={value.ultiProPropertyID + "locUltiPro"}
                                  value={value.ultiProPropertyID}
                                >
                                  {value.description}
                                </MenuItem>
                              ))}
                            </Select>
                          ) : (
                            <span>{row.ultiProPropertyDescription}</span>
                          )}
                        </TableCell>
                        <TableCell align={"right"}>
                          {this.state.IdToEdit == row.propertyID ? (
                            <TextField
                              disabled
                              id={"standard-basic"}
                              value={this.state.DwIdByAPI}
                            />
                          ) : (
                            row.dwPropertyId
                          )}
                        </TableCell>
                        <TableCell align={"right"}>
                          {this.state.IdToEdit == row.propertyID ? (
                            <Checkbox
                              checked={this.state.isEnable == 1 ? true : false}
                              value={this.state.isEnable == 1 ? true : false}
                              color={"primary"}
                              onChange={e => {
                                this.changeCheckBox(e.target.checked);
                              }}
                              inputProps={{
                                "aria-label": "secondary checkbox"
                              }}
                            />
                          ) : (
                            <Checkbox
                              checked={row.statusID == 1 ? true : false}
                              value={row.statusID == 1 ? true : false}
                              color={"primary"}
                              disabled
                              inputProps={{
                                "aria-label": "secondary checkbox"
                              }}
                            />
                          )}
                        </TableCell>
                        <TableCell align={"right"}>
                          {this.state.IdToEdit != row.propertyID ? (
                            DATA_CENTER == true ? (
                              <Tooltip
                                title={"Edit"}
                                onClick={() =>
                                  this.handelDataCenterChange(
                                    row.propertyID,
                                    row,
                                    row.ultiProLocationId,
                                    row.ultiProPropertyId
                                  )}
                              >
                                <IconButton size={"small"}>
                                  <EditIcon size={"small"} />
                                </IconButton>
                              </Tooltip>
                            ) : null
                          ) : (
                            <>
                              <Tooltip title={"Save"}>
                                <IconButton
                                  size={"small"}
                                  onClick={() => this.saveRecord()}
                                >
                                  <SaveIcon size={"small"} />
                                </IconButton>
                              </Tooltip>

                              <Tooltip
                                title={"Cancel"}
                                onClick={() => {
                                  this.setState({
                                    IdToEdit: null,
                                    isEnable: 1,
                                    selectedPropertyUltipro: [],
                                    ultiProLocationId: undefined
                                  });
                                }}
                              >
                                <IconButton size={"small"}>
                                  <CancelIcon size={"small"} />
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </>
    );
  }
}

export default ConfigureDC;
